'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.addLinkedEmailWidget = function (subscriptionModel) {
	return mmWidgets.each(this, function () {
		const widget = this,
			emailField = widget.find('[name="linked-email-address"]'),
			linkEmailButton = widget.find('[data-mm-role~="link-email-address"]'),
			validatedEmail = function (email) {
				if (!email || (email.length > 2 && email.indexOf('@') > 0)) {
					return email;
				}
			},
			validateEmail = function (dontMark) {
				const email = validatedEmail(emailField.val()),
					controlBlock = emailField.parent();
				let valid = true;

				controlBlock.removeClass('error');
				if (!email) {
					valid = false;
				}
				if (!dontMark && !valid && emailField.val()) {
					controlBlock.addClass('error');
				}
				return valid && email;
			},
			validate = function (dontMark) {
				const validEmail = validateEmail(dontMark);
				if (validEmail) {
					linkEmailButton.removeClass('disabled');
					return validEmail;
				} else {
					linkEmailButton.addClass('disabled');
				}
			},
			validateAndMark = function () {
				validate();
			};
		emailField.blur(validateAndMark).focus(validateAndMark).on('keyup', validateAndMark);
		validate(true);
		subscriptionModel.addEventListener('goldAccountInfo', function () {
			emailField.val('');
			validate(true);
			widget.find('[data-mm-role="error"]').addClass('hidden');
		});
		linkEmailButton.click(function () {
			const emailToLink = validate();
			if (!emailToLink) {
				return;
			}
			widget.find('[data-mm-role="error"]').addClass('hidden');
			subscriptionModel.addLinkedEmail(emailToLink).catch(function (reason) {
				const knownError = widget.find('[data-mm-role="error"][data-mm-reason="' +  reason + '"]');
				if (knownError.length) {
					knownError.removeClass('hidden');
				} else {
					widget.find('[data-mm-role="error"]:not([data-mm-reason])').removeClass('hidden');
				}
			});
		});

	});
};
